/**
 * Enum encapsulating Javascript Keycodes
 ** keyCodes are deprecated and no longer recommended for use. Recommend using 'Key' enum instead.
 ** See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
 */ export var KeyCode = /*#__PURE__*/ function(KeyCode) {
    KeyCode[KeyCode["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["SHIFT"] = 16] = "SHIFT";
    KeyCode[KeyCode["CTRL"] = 17] = "CTRL";
    KeyCode[KeyCode["ALT"] = 18] = "ALT";
    KeyCode[KeyCode["PAUSE"] = 19] = "PAUSE";
    KeyCode[KeyCode["CAPS_LOCK"] = 20] = "CAPS_LOCK";
    KeyCode[KeyCode["ESCAPE"] = 27] = "ESCAPE";
    KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
    KeyCode[KeyCode["PAGE_UP"] = 33] = "PAGE_UP";
    KeyCode[KeyCode["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KeyCode[KeyCode["END"] = 35] = "END";
    KeyCode[KeyCode["HOME"] = 36] = "HOME";
    KeyCode[KeyCode["LEFT_ARROW"] = 37] = "LEFT_ARROW";
    KeyCode[KeyCode["UP_ARROW"] = 38] = "UP_ARROW";
    KeyCode[KeyCode["RIGHT_ARROW"] = 39] = "RIGHT_ARROW";
    KeyCode[KeyCode["DOWN_ARROW"] = 40] = "DOWN_ARROW";
    KeyCode[KeyCode["INSERT"] = 45] = "INSERT";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
    KeyCode[KeyCode["D"] = 68] = "D";
    KeyCode[KeyCode["I"] = 73] = "I";
    KeyCode[KeyCode["M"] = 77] = "M";
    KeyCode[KeyCode["N"] = 78] = "N";
    KeyCode[KeyCode["Y"] = 89] = "Y";
    KeyCode[KeyCode["Z"] = 90] = "Z";
    KeyCode[KeyCode["F1"] = 112] = "F1";
    KeyCode[KeyCode["F2"] = 113] = "F2";
    KeyCode[KeyCode["F3"] = 114] = "F3";
    KeyCode[KeyCode["F4"] = 115] = "F4";
    KeyCode[KeyCode["F5"] = 116] = "F5";
    KeyCode[KeyCode["F6"] = 117] = "F6";
    KeyCode[KeyCode["F7"] = 118] = "F7";
    KeyCode[KeyCode["F8"] = 119] = "F8";
    KeyCode[KeyCode["F9"] = 120] = "F9";
    KeyCode[KeyCode["F10"] = 121] = "F10";
    KeyCode[KeyCode["F11"] = 122] = "F11";
    KeyCode[KeyCode["F12"] = 123] = "F12";
    KeyCode[KeyCode["EQUALS_PLUS"] = 187] = "EQUALS_PLUS";
    KeyCode[KeyCode["HYPHEN_UNDERSCORE"] = 189] = "HYPHEN_UNDERSCORE";
    KeyCode[KeyCode["FIREFOX_EQUALS_PLUS"] = 61] = "FIREFOX_EQUALS_PLUS";
    KeyCode[KeyCode["FIREFOX_HYPHEN_UNDERSCORE"] = 173] = "FIREFOX_HYPHEN_UNDERSCORE";
    KeyCode[KeyCode["Comma"] = 188] = "Comma";
    KeyCode[KeyCode["Period"] = 190] = "Period";
    return KeyCode;
}({});
/**
 * Enum encapsulating Javascript's KeyboardEvent.key values
 */ export var Key = /*#__PURE__*/ function(Key) {
    Key["ENTER"] = "Enter";
    Key["ESCAPE"] = "Escape";
    Key["SPACE"] = " ";
    Key["UP_ARROW"] = "ArrowUp";
    Key["DOWN_ARROW"] = "ArrowDown";
    Key["LEFT_ARROW"] = "ArrowLeft";
    Key["RIGHT_ARROW"] = "ArrowRight";
    Key["TAB"] = "Tab";
    Key["DELETE"] = "Delete";
    Key["COMMA"] = ",";
    Key["PERIOD"] = ".";
    Key["F6"] = "F6";
    return Key;
}({});
